import React, { useEffect, useState } from 'react';
import { formatMoney, formatNumber } from '../../utils/formatters';
import { getHrPayslip } from '../../services/api';
import { rateLabel, unitOf, DAY_CODES } from './tsFormat';

/* Расчётный листок: из чего сложилась сумма у человека за месяц. Печатается
   как есть — @media print скрывает всё, кроме этого блока, поэтому отдельная
   версия страницы для печати не нужна. */

const PayslipModal = ({ entryId, onClose, onRemove }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    getHrPayslip(entryId)
      .then(result => { if (alive) setData(result); })
      .catch(() => { if (alive) setError('Не удалось загрузить расчётный листок'); });
    return () => { alive = false; };
  }, [entryId]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const entry = data?.entry;
  const labels = data?.day_type_labels || {};

  return (
    <div className="ui-modal hr-print-overlay" onClick={onClose}>
      <div className="ui-modal-box wide hr-payslip" onClick={(e) => e.stopPropagation()}>
        <div className="ui-modal-head hr-no-print">
          <h2>Расчётный листок</h2>
          <button className="ui-icon-btn" onClick={onClose} aria-label="Закрыть">×</button>
        </div>

        {error && <div className="ui-inline-error">{error}</div>}

        {entry && (
          <div className="hr-payslip-sheet">
            <div className="hr-payslip-head">
              <div>
                <div className="hr-payslip-org">{data.organization}</div>
                <div className="hr-payslip-title">Расчётный листок за {data.period.label}</div>
              </div>
              <div className="hr-payslip-person">
                <div className="hr-payslip-name">{entry.full_name}</div>
                <div className="ui-dim">{entry.position}</div>
              </div>
            </div>

            <dl className="ui-defs hr-payslip-defs">
              <div>
                <dt>Тип оплаты</dt>
                <dd>{rateLabel(entry.pay_type, entry.rate)}</dd>
              </div>
              <div><dt>Отработано дней</dt><dd>{entry.worked_days}</dd></div>
              {entry.pay_type !== 'salary' && (
                <div>
                  <dt>{entry.pay_type === 'shift' ? 'Смен' : 'Отработано часов'}</dt>
                  <dd>{formatNumber(entry.hours)} {unitOf(entry.pay_type, entry.hours)}</dd>
                </div>
              )}
              {entry.vacation_days > 0 && <div><dt>Отпуск, дней</dt><dd>{entry.vacation_days}</dd></div>}
              {entry.sick_days > 0 && <div><dt>Больничный, дней</dt><dd>{entry.sick_days}</dd></div>}
              {entry.dayoff_days > 0 && <div><dt>Выходных отмечено</dt><dd>{entry.dayoff_days}</dd></div>}
              <div><dt>За 1–15 число</dt><dd>{formatMoney(entry.advance1)}{entry.adv1_manual ? ' (вручную)' : ''}</dd></div>
              <div><dt>За 16 число — конец месяца</dt><dd>{formatMoney(entry.advance2)}{entry.adv2_manual ? ' (вручную)' : ''}</dd></div>
              <div><dt>Доплаты</dt><dd>{formatMoney(entry.bonus)}</dd></div>
              <div><dt>Штрафы</dt><dd>{entry.fines ? `− ${formatMoney(entry.fines)}` : formatMoney(0)}</dd></div>
              <div><dt>Итого за месяц</dt><dd className="hr-payslip-total">{formatMoney(entry.total)}</dd></div>
            </dl>

            {data.days.length > 0 && (
              <>
                <h3 className="hr-payslip-subtitle">По дням</h3>
                <div className="hr-payslip-days">
                  {data.days.map(day => (
                    <span key={day.day} className={`hr-payslip-day ${day.day_type !== 'work' ? day.day_type : ''}`}>
                      <b>{day.day}</b>
                      {day.day_type === 'work'
                        ? (entry.pay_type === 'salary' ? 'был' : `${formatNumber(day.hours)} ${unitOf(entry.pay_type, day.hours)}`)
                        : (day.mark || labels[day.day_type] || DAY_CODES[day.day_type])}
                    </span>
                  ))}
                </div>
              </>
            )}

            <p className="ui-dim hr-payslip-note">
              Расчёт по данным табеля на {new Date().toLocaleDateString('ru-RU')}.
              {data.period.status === 'closed' ? ' Период закрыт.' : ' Период ещё открыт, суммы могут измениться.'}
            </p>
          </div>
        )}

        <div className="ui-modal-actions hr-no-print">
          {onRemove && entry && (
            <button type="button" className="ui-btn-danger ts-remove-entry" onClick={onRemove}>
              Убрать из табеля
            </button>
          )}
          <button type="button" className="ui-btn-ghost" onClick={onClose}>Закрыть</button>
          <button type="button" className="ui-btn-primary" onClick={() => window.print()} disabled={!entry}>
            Печать
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayslipModal;
